// search-form.js はヘッダーで読み込むため、ヘッダーが無いページでは SearchForm が無い
if (typeof SearchForm !== "undefined" && !customElements.get("predictive-search")) {
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]"
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";

    this.allowedCollectionHandles = ["all"];

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  filterSearchResults(resultsMarkup) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(resultsMarkup, "text/html");

    const productItems = doc.querySelectorAll(
      '[data-search-result-type="product"]'
    );

    productItems.forEach((item) => {
      const collectionsAttr = item.getAttribute("data-product-collections");

      if (!collectionsAttr) {
        item.remove();
        return;
      }

      const collections = collectionsAttr.split(",").map((h) => h.trim());

      const hasAllowedCollection = collections.some((handle) =>
        this.allowedCollectionHandles.includes(handle)
      );

      if (!hasAllowedCollection) {
        item.remove();
      }
    });

    const collectionItems = doc.querySelectorAll(
      '[data-search-result-type="collection"]'
    );
    collectionItems.forEach((item) => item.remove());

    const pageItems = doc.querySelectorAll('[data-search-result-type="page"]');

    pageItems.forEach((item) => {
      const metafieldValue = item.getAttribute("data-page-metafield");

      if (!metafieldValue || metafieldValue.trim() === "") {
        item.remove();
      }
    });

    return doc.querySelector("#shopify-section-predictive-search").innerHTML;
  }

  parseSearchResultsHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const productCards = doc.querySelectorAll('.card-wrapper, .product-card, .grid__item');
    const articleCards = doc.querySelectorAll('.article-card, .blog__post');

    const pageCards = [];
    const allGridItems = doc.querySelectorAll('.grid__item');

    allGridItems.forEach(item => {
      const link = item.querySelector('a[href*="/pages/"]');
      if (link) {
        let metafield = item.getAttribute('data-page-metafield');

        if (!metafield || metafield === 'null' || metafield.trim() === '') {
          const categoryElement = item.querySelector('.card__category, .page-category, [class*="category"]');
          if (categoryElement) {
            metafield = categoryElement.textContent.trim();
          }
        }

        const titleElement = item.querySelector('.card__heading, h3, h2, .page-title');
        const title = titleElement ? titleElement.textContent.trim() : link.textContent.trim();

        pageCards.push({
          element: item,
          url: link.getAttribute('href'),
          title: title,
          metafield: metafield || ''
        });
      }
    });

    let resultsHTML = '<div id="shopify-section-predictive-search"><div id="predictive-search-results" role="listbox">';
    resultsHTML += '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">';

    let totalResults = 0;

    if (productCards.length > 0) {
      resultsHTML += '<div class="predictive-search__result-group">';
      resultsHTML += '<h2 id="predictive-search-products" class="predictive-search__heading">商品</h2>';
      resultsHTML += '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group">';

      let productIndex = 0;
      productCards.forEach((card) => {
        if (productIndex >= 10) return;

        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;

        const productUrl = link.getAttribute('href');
        const title = card.querySelector('.card__heading, .product-card__title, h3');
        const image = card.querySelector('img');

        const collections = 'all';

        resultsHTML += `
          <li id="predictive-search-option-product-${productIndex}" 
              class="predictive-search__list-item" 
              role="option" 
              aria-selected="false"
              data-search-result-type="product"
              data-product-collections="${collections}"
              data-product-url="${productUrl}">
            <a href="${productUrl}" class="predictive-search__item predictive-search__item--link-with-thumbnail link" tabindex="-1">
              ${image ? `<img class="predictive-search__image" src="${image.src}" alt="${image.alt || ''}" width="50">` : ''}
              <div class="predictive-search__item-content">
                <p class="predictive-search__item-heading h5">${title ? title.textContent.trim() : ''}</p>
              </div>
            </a>
          </li>
        `;
        productIndex++;
        totalResults++;
      });

      resultsHTML += '</ul></div>';
    }

    if (pageCards.length > 0) {
      resultsHTML += '<div class="predictive-search__result-group">';
      resultsHTML += '<h2 id="predictive-search-special-pages" class="predictive-search__heading">特集・コンテンツ</h2>';
      resultsHTML += '<ul id="predictive-search-results-special-pages-list" class="predictive-search__results-list list-unstyled" role="group">';

      pageCards.forEach((page, index) => {
        if (index >= 10) return;

        resultsHTML += `
          <li id="predictive-search-option-special-page-${index}" 
              class="predictive-search__list-item special-content-page-item" 
              role="option" 
              aria-selected="false"
              data-search-result-type="page"
              data-page-metafield="${page.metafield}">
            <a href="${page.url}" class="predictive-search__item link" tabindex="-1">
              <div class="predictive-search__item-content">
                <p class="predictive-search__item-heading h5">${page.title}</p>
              </div>
            </a>
          </li>
        `;
        totalResults++;
      });

      resultsHTML += '</ul></div>';
    }

    if (articleCards.length > 0) {
      resultsHTML += '<div class="predictive-search__result-group">';
      resultsHTML += '<h2 id="predictive-search-articles" class="predictive-search__heading">記事</h2>';
      resultsHTML += '<ul id="predictive-search-results-articles-list" class="predictive-search__results-list list-unstyled" role="group">';

      articleCards.forEach((card, index) => {
        if (index >= 10) return;

        const link = card.querySelector('a');
        if (!link) return;

        const articleUrl = link.getAttribute('href');
        const title = card.querySelector('.article-card__title, h3, h2');

        resultsHTML += `
          <li id="predictive-search-option-article-${index}" 
              class="predictive-search__list-item" 
              role="option" 
              aria-selected="false"
              data-search-result-type="article">
            <a href="${articleUrl}" class="predictive-search__item link" tabindex="-1">
              <div class="predictive-search__item-content">
                <p class="predictive-search__item-heading h5">${title ? title.textContent.trim() : ''}</p>
              </div>
            </a>
          </li>
        `;
        totalResults++;
      });

      resultsHTML += '</ul></div>';
    }

    resultsHTML += '</div>';
    resultsHTML += `<span class="hidden" data-predictive-search-live-region-count-value>${totalResults}件の結果</span>`;
    resultsHTML += '</div></div>';

    return resultsHTML;
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const requestUrl = `/search/suggest?q=${encodeURIComponent(
      searchTerm
    )}&resources[type]=product,article,page&resources[limit]=10&section_id=predictive-search`;

    fetch(requestUrl, {
      signal: this.abortController.signal,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          if (response.status === 417) {
            return this.fallbackToStandardSearch(searchTerm);
          }

          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.json();
      })
      .then((data) => {
        if (data.resources && data.resources.results) {
          if (data.sections && data.sections["predictive-search"]) {
            const resultsMarkup = data.sections["predictive-search"];

            const filteredMarkup = this.filterSearchResults(resultsMarkup);

            this.allPredictiveSearchInstances.forEach(
              (predictiveSearchInstance) => {
                predictiveSearchInstance.cachedResults[queryKey] =
                  filteredMarkup;
              }
            );

            this.renderSearchResults(filteredMarkup);
          } else {
            this.fallbackToStandardSearch(searchTerm);
          }
        } else {
          this.fallbackToStandardSearch(searchTerm);
        }
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }

        this.fallbackToStandardSearch(searchTerm);
      });
  }

  fallbackToStandardSearch(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    const requestUrl = `/search?q=${encodeURIComponent(
      searchTerm
    )}&type=product,article,page&view=json`;

    return fetch(requestUrl, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((html) => {
        const resultsMarkup = this.parseSearchResultsHTML(html);

        const filteredMarkup = this.filterSearchResults(resultsMarkup);

        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = filteredMarkup;
          }
        );

        this.renderSearchResults(filteredMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    if (this.statusElement) {
      this.setLiveRegionText(this.loadingText);
    }
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    if (!this.statusElement) {
      return;
    }

    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      if (this.statusElement) {
        this.statusElement.setAttribute("aria-hidden", "true");
      }
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        .textContent
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}

customElements.define("predictive-search", PredictiveSearch);
}